import { render, staticRenderFns } from "./PropertyInput.vue?vue&type=template&id=a64a54fa&scoped=true"
import script from "./PropertyInput.vue?vue&type=script&lang=js"
export * from "./PropertyInput.vue?vue&type=script&lang=js"
import style0 from "./PropertyInput.vue?vue&type=style&index=0&id=a64a54fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a54fa",
  null
  
)

export default component.exports